import React, {
  useEffect,
  useCallback,
  useState,
  useRef,
  useContext,
} from "react";
import { firestore } from "../firebase/firebase";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import {
  // BrowserRouter as Router,
  // Switch,
  Route,
  // Link,
  useHistory,
  // Redirect,
  useParams,
} from "react-router-dom";

import { UserContext } from "../providers/UserProvider";
import { useBookingEvents } from '../hooks/useBookingEvents';

import { Button } from "@material-ui/core";
// import IconButton from '@material-ui/core/IconButton';

// import AddIcon from "@material-ui/icons/Add";
// import DeleteIcon from "@material-ui/icons/Delete";
// import SaveIcon from "@material-ui/icons/Save";
// import TimelapseIcon from '@material-ui/icons/Timelapse';
import SettingsIcon from '@material-ui/icons/Settings';


function Store() {

  const { user } = useContext(UserContext);
  let { storeId } = useParams();
  storeId = useRef(storeId);
  const [store, setStore] = useState(null);
  const events = useBookingEvents(storeId.current);
  const classes = useStyles();
  let history = useHistory();
  const isMounted = useRef(false);
  const storeRef = firestore.collection('stores').doc(storeId.current);

  const getStore = useCallback(async () => {
    try {

      const storeSnapshot = await storeRef.get();

      if (storeSnapshot.exists) {
        const data = storeSnapshot.data();
        isMounted.current && setStore(data);
      }
    } catch (error) {
      console.error(error);
    }
  }, [storeRef]);

  useEffect(() => {
    isMounted.current = true;
    getStore();

    return (
      () => {
        isMounted.current = false;
      }
    );
  }, [getStore]);

  // useEffect(() => {
  //   let nbr = 0;
  //   for (const e in events) {
  //     nbr++;
  //     console.log("event id: ", events[e].id);
  //   }

  // }, [events]);

  

  const handleBookableSlots = () => {
    history.push("/butiker/" + storeId.current + "/bokningsbara-tider");
  };

  const handleBook = (eventId) => {
    history.push("/butiker/" + storeId.current + "/boka-tid/" + eventId);
  }

  return (
    <Route
      render={() =>

        <div style={{ textAlign: "left" }}>
          <Typography
            component="h1"
            variant="h5"
            color="primary"
            style={{ textAlign: "left", marginBottom: 30 }}
          >
            {store?.name}
          </Typography>

          {user.accessLevel === 10 &&
            <Button
              variant='outlined'
              color="primary"
              style={{
                marginTop: 9,
                marginLeft: 0,
                marginBottom: 20,
              }}
              onClick={handleBookableSlots}
              startIcon={<SettingsIcon />}
            >
              Populeringsinställningar
            </Button>
          }

          <Paper className={classes.paper}>
            <div
              style={{ width: "100%" }}
              className={classes.root}
            >
              <Typography
                component="h3"
                variant="h6"
                color="primary"
                style={{ textAlign: "left", marginBottom: 30 }}
              >
                Aktuella bokningar
              </Typography>
              <TableContainer>
                <Table size='small' aria-label="Aktuella bokningar">
                  <TableHead>
                    <TableRow>
                      <TableCell>Dag</TableCell>
                      <TableCell align='right'>Platser kvar</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.keys(events).map((key) => {
                      const event = events[key];
                      let nbrOfFree = 0;
                      event.slots?.forEach(slot => {
                        let free = slot.max - slot.count;
                        free = free < 0 ? 0 : free;
                        nbrOfFree += free;
                      });
                      return (
                        <TableRow
                          key={event.id}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleBook(event.id)}
                        >
                          <TableCell compoent='th' scope='row'>{event.dateString}</TableCell>
                          <TableCell align='right'>{nbrOfFree}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>

            </div>
          </Paper>
        </div>

        // <Redirect to="/" />

      }
    />
  );
}

export default Store;




const useStyles = makeStyles((theme) => ({
  root: {
    "& div.MuiDataGrid-row": {
      //   cursor: "pointer",
    },
  },
  seeMore: {
    marginTop: theme.spacing(3),
    table: {
      minWidth: 650,
    },
  },
  searchForm: {
    width: "100%",
    marginBottom: 40,
  },
  searchInput: {
    width: "50%",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  formControl: {
    marginRight: theme.spacing(1),
    width: 150,
    marginBottom: 30,
    // textAlign: 'left',
  },
  ul: {
    marginBottom: 50,
    "& li": {
      marginBottom: 10,
    },
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    // width: 200,
  },
  input: {
    height: 'auto',
  },

}));
